<template>
    <div class="content">
        <div class="title">企业风采</div>
        <div class="imgs">
            <div
                v-for="(item,index) in webInfo.about.qyfc"
                :key="index"
                :src="item"
                class="img"
                :style="{backgroundImage:'url('+item+')'}"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
.content {
    width: 1260px;
    padding: 50px 30px 0px 30px;
    overflow: visible;

    .title {
        font-size: 25px;
        color: #333333;
    }
    .imgs {
        margin-top: 50px;
        display: flex;
        flex-wrap: wrap;

        .img {
            width: 400px;
            height: 264px;
            cursor: pointer;
            transition: all 0.3s;
            background-position: center;
            &:hover {
                transform: scale(1.1);
                z-index: 99;
            }
        }
    }
}
</style>
